<template>
  <div id="reservation-page">
        <h1 class="title is-2">{{ $t('Messaging.title') }}</h1>
    <div class="card">
      <div class="card-content">
        <div class="block">
          <div class>
            <h3 class="title is-5">{{ $t('Messaging.totalSubscribers') }} {{count}}</h3>
          </div>
        </div>

        <div class="field">
          <label class="label">{{ $t('Messaging.msgTitle') }}</label>
          <div class="input-with-emoji-wrapper">
          <p class="control">
            <input type="text" class="input" v-model="message.subject">
          </p>
          <emoji-picker @emoji="appendSubject" :search="search" class="is-hidden-mobile">
                <div
                  class="emoji-invoker"
                  slot="emoji-invoker"
                  slot-scope="{ events: { click: clickEvent } }"
                  @click.stop="clickEvent"
                >
                  <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 0h24v24H0z" fill="none"/>
                    <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"/>
                  </svg>
                </div>
                <div slot="emoji-picker" slot-scope="{ emojis, insert, display }">
                  <div class="emoji-picker" :style="{ top: display.y + 'px', left: display.x + 'px' }">
                    <div class="emoji-picker__search">
                      <input type="text" v-model="search" v-focus>
                    </div>
                    <div>
                      <div v-for="(emojiGroup, category) in emojis" :key="category">
                        <h5>{{ category }}</h5>
                        <div class="emojis">
                          <span
                            v-for="(emoji, emojiName) in emojiGroup"
                            :key="emojiName"
                            @click="insert(emoji)"
                            :title="emojiName"
                          >{{ emoji }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </emoji-picker>     
              </div>
        </div>
        <div class="field">
          <label class="label">{{ $t('Messaging.msgText') }}</label>
          <div class="control">
        <div class="input-with-emoji-wrapper">
              <textarea class="textarea" v-model="message.body"></textarea>
              <emoji-picker @emoji="appendBody" :search="search" class="is-hidden-mobile">
                <div
                  class="emoji-invoker"
                  slot="emoji-invoker"
                  slot-scope="{ events: { click: clickEvent } }"
                  @click.stop="clickEvent"
                >
                  <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 0h24v24H0z" fill="none"/>
                    <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"/>
                  </svg>
                </div>
                <div slot="emoji-picker" slot-scope="{ emojis, insert, display }">
                  <div class="emoji-picker" :style="{ top: display.y + 'px', left: display.x + 'px' }">
                    <div class="emoji-picker__search">
                      <input type="text" v-model="search" v-focus>
                    </div>
                    <div>
                      <div v-for="(emojiGroup, category) in emojis" :key="category">
                        <h5>{{ category }}</h5>
                        <div class="emojis">
                          <span
                            v-for="(emoji, emojiName) in emojiGroup"
                            :key="emojiName"
                            @click="insert(emoji)"
                            :title="emojiName"
                          >{{ emoji }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </emoji-picker>            
            </div>
          </div>
        </div>

        <label class="label">{{ $t('Messaging.image') }}</label>
        <div class="field has-addons">
          <div class="control" style="width: 100%;">
            <input
              class="input"
              type="text"
              :placeholder="$t('Messaging.imagePlaceholder')"
              v-model="imageUrl"
            >
          </div>
          <div class="control">
            <a class="button is-info" @click="$filestack.picker(options).open()">{{ $t('Messaging.upload') }}</a>
          </div>
        </div>

        <button
          class="button btn-cta mt-2" style="min-width:150px;"
          @click="confirmSend"
          
        ><span class="icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-send"><line class="st0" x1="21.5" y1="12" x2="6" y2="12"></line>
              <polygon class="st0" points="21.5,12 2.5,21.2 6,12 2.5,2.8 	"></polygon></svg>
              </span></button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import _ from "underscore";
import api from "../api";

export default {
  name: "Messaging",
  computed: _.extend(
    {},
    mapGetters({
      place: "getPlaceInfo",
      identityId: "getIdentityId"
    }),
    {}
  ),
  data() {
    return {
      isLoading: false,
      message: {subject: "", body: ""},
      count: "",
      imageUrl: "",
      imageLastUpdated: "",
      input: '',
      search: '',
      display: {x: 100, y: 100},
      options: {
        lang: this.$i18n.locale,
        fromSources: ["local_file_system", "instagram", "facebook"],
        accept: ["image/*"],
        transformations: {
          crop: {
            aspectRatio: 3 / 1,
            force: true
          },
          circle: false,
          rotate: false
        },
        onFileUploadFinished: file => {
          this.imageUrl = file.url;
          this.$ma.trackEvent({
            category: "event",
            action: "Image uploaded for PUSH message",
            properties: {"url": file.url}
          }); 
        }
      }
    };
  },

  methods: _.extend({}, mapActions(["updatePlaceInfo"]), {
    sendPush: function() {
 
      var params = {
        url: this.place.url,
        cid: this.identityId,
        payload: {
          subject: this.message.subject,
          body: this.message.body,
          image: this.imageUrl
        }
      };
      api.sendPush(params);
      this.$ma.trackEvent({
        category: "event",
        action: "PUSH-notification sent",
        properties: ""
      });
    },

    // unique itemId generator
    generateRowId(subid) {
      var EPOCH = 1300000000000;
      var ts = new Date().getTime() - EPOCH; // limit to recent
      var randid = Math.floor(Math.random() * 512);
      ts = ts * 64; // bit-shift << 6
      ts = ts + subid;
      return ts * 512 + (randid % 512);
    },

    removeAttachedImage() {
      this.$ma.trackEvent({
        category: "event",
        action: "Image removed from PUSH message",
        properties: {}
      });

      this.imageUrl = "";

      // this.$forceUpdate();
      // TODO: remove file from folder
    },

    appendSubject(emoji) {
      this.message.subject += emoji
    },
    appendBody(emoji) {
      this.message.body += emoji
    },

    confirmSend() {
                this.$buefy.dialog.confirm({
                    title: this.$t('Messaging.confirmationTitle'),
                    message: this.$t('Messaging.confirmationText'),
                    confirmText: this.$t('Messaging.send'),
                    cancelText: this.$t('Messaging.cancel'),
                    type: 'is-warning',
                    hasIcon: true,
                    icon: 'paper-plane',
                    onConfirm: () => {
                      this.sendPush()
                      this.$buefy.toast.open(this.$t('Messaging.messageSent'))

                      }
                })
            },
  }),
  mounted() {
    this.$title = this.$t('title') + " | " + this.$t('Messaging.title')
    this.$ma.trackEvent({
      category: "event",
      action: "Page viewed: Messaging",
      label: null,
      value: null
    });
    api.getPushSubscribersCount({ url: this.place.url }).then(response => {
      console.log(response);
      this.count = response.data;
    });
  }
};
</script>
